import { Route } from 'react-router';

import DataCatalog from './DataCatalog';
import routes from './routes';

const DataCatalogRoutes = [
    <Route
        path={routes.dataCatalog}
        key="data-catalog"
        element={<DataCatalog />}
    />,
];
export default DataCatalogRoutes;
